module.exports = __webpack_public_path__ + "static/media/agency.59426f56.svg";